(function () {
    const sections = document.querySelectorAll("#HomePageSlider");
    sections.forEach((carousel) => {
        const videos = carousel.querySelectorAll('video[id^="video-"]');

        if (!carousel || videos.length === 0) return;

        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        function getControls(video) {
            const id = video.id.split("video-")[1];
            return {
                btnMuted: carousel.querySelector(`#sound-muted-${id}`),
                btnUnmuted: carousel.querySelector(`#sound-unmuted-${id}`)
            };
        }

        function muteVideo(video) {
            video.muted = true;
            const { btnMuted, btnUnmuted } = getControls(video);
            if (btnMuted) btnMuted.style.display = "block";
            if (btnUnmuted) btnUnmuted.style.display = "none";
        }

        function muteAllVideos() {
            videos.forEach(v => muteVideo(v));
        }

        videos.forEach(video => {
            const { btnMuted, btnUnmuted } = getControls(video);
            const isActive = video.closest(".carousel-item.active") !== null;

            if (!prefersReducedMotion) {
                if (isActive) {
                    video.setAttribute("autoplay", "true");
                    video.play().catch(() => console.log(`Failed to play video: ${video.id}`));
                }
            }

            // MUTE
            if (btnUnmuted) {
                btnUnmuted.addEventListener("click", function (e) {
                    e.preventDefault();
                    muteVideo(video);
                });
            }

            // UNMUTE
            if (btnMuted) {
                btnMuted.addEventListener("click", function (e) {
                    e.preventDefault();
                    muteAllVideos();
                    video.muted = false;
                    video.volume = 0.3;
                    btnMuted.style.display = "none";
                    btnUnmuted.style.display = "block";
                });
            }
        });

        if (carousel && !prefersReducedMotion) {
            carousel.addEventListener("slid.bs.carousel", function (e) {
                videos.forEach(v => {
                    v.pause();
                    muteVideo(v);
                });

                const activeVideo = e.relatedTarget.querySelector("video");
                if (activeVideo) {
                    activeVideo.play().catch(() => console.log(`Failed to play video: ${activeVideo.id}`));
                }
            });
        }
    })
})();